var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewOptionBase',{style:(_vm.setStyle),attrs:{"show":_vm.show,"goal":_vm.goal,"problem":_vm.problem,"solution":_vm.solution,"requested":_vm.requested,"image":'https://mylastwill.s3.amazonaws.com/static/img/advice-ppt.png',"title":_vm.title},on:{"selected":function($event){return _vm.$emit('selected')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }